<div class="popup-wrapper" [class.is-earning]="isEarning" [class.is-active]="show" [class.is-blurred]="blur">
    <div class="popup-wrapper__inner" *ngIf="show">
        <button class="popup-wrapper__close" (click)="closePopup()"></button>
        <div class="popup-wrapper__scrolled">
            <ng-content></ng-content>
        </div>
    </div>
</div>
